<template>
  <div class="promotion-scene">
    <div class="promotion-card" :class="{ 'is-flipped': flipped}">

      <div class="promotion-card__face promotion-card__face--front">
        <v-card>

          <v-card-media
            height="400px"
            :src="data.cover.path"
          ></v-card-media>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn icon @click="flipped=true">
              <v-icon>info</v-icon>
            </v-btn>
          </v-card-actions>

        </v-card>
      </div>

      <div class="promotion-card__face promotion-card__face--back">
        <v-card>

          <v-card-title primary-title>
            <div>
              <h3>{{ data.name }}</h3>
              <div class="grey--text" v-html="data.description"></div>
              <div>
              <v-chip v-for="c in data.categories" :key="c.id" outline color="secondary">
                {{ c.name }}
              </v-chip>
              </div>
            </div>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn icon @click="flipped=false">
              <v-icon>keyboard_return</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    flipped: false
  }),
  props: {
    data: {required: true}
  }
}
</script>

<style>
.promotion-scene {
  height: 450px;
  perspective: 600px;
}

.promotion-card {
  width: 100%;
  height: 100%;
  position: relative;
  transition: transform 1s;
  transform-style: preserve-3d;
}

.promotion-card__face {
  position: absolute;
  height: 100%;
  width: 100%;
  backface-visibility: hidden;
}

.promotion-card__face--back {
  transform: rotateY( 180deg );
}

.promotion-card__face--back .card__title {
  height: 400px;
  overflow: scroll;
}

.promotion-card.is-flipped {
  transform: rotateY(180deg);
}
</style>


// WEBPACK FOOTER //
// src/components/promotions/Item.vue